import { useEffect, useState } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Button,
  Paper,
  IconButton,
  Box
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Edit } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import CustomModal from "../../../../../components/Modal";
import "../../../css/edit-domains.css";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export default function EditUserIPs({ user, anycastIPs, handleCloseModal }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  useEffect(() => {
    if (anycastIPs.length > 0 && user) {
      const userAnycast = user.anycastips ? user.anycastips.split(",") : [];
      const userIPs = [];
      const leftIPs = [];

      anycastIPs.map((a) => {
        if (userAnycast.includes(a)) {
          userIPs.push(a);
        } else {
          leftIPs.push(a);
        }
      });

      setLeft(userIPs);
      setRight(leftIPs);
    }
  }, [user, anycastIPs]);

  const onEdit = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("uid", user.id);

    const selectedIPs = [];
    left.map((q) => {
      selectedIPs.push(q);
    });
    formData.append("anycastips", selectedIPs);

    api.post(ApiUrls.user.edit, formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          handleCloseModal();
          showStatus("success_user_ip");
        } else {
          showStatus("error_user_ip");
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error_user_ip");
      });
  }

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  const customList = (items) => (
    <Paper sx={{ width: '100%', height: 230, overflow: 'auto', p: 2 }} className="transfer-list-paper">
      <List dense component="div" role="list">
        {items.map((value, i) => {
          const labelId = `transfer-list-ip-${i}-label`;

          return (
            <ListItem
              className="py-1"
              key={`transfer-list-ip-${i}`}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value} />
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );

  return (
    <>
      <IconButton onClick={handleOpen}>
        <Edit />
      </IconButton>

      {modalOpen &&
        <CustomModal open={modalOpen} handleClose={handleClose} title={t("user.ip_edit")} >
          <Box py={2} px={{ md: 5, xs: 2 }} className="edit-user-domain">
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item md={5} className="text-center">
                <div className="transfer-title mb-3">IPها</div>
                {customList(right)}
              </Grid>
              <Grid item>
                <Grid container direction="column" alignItems="center">
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleAllLeft}
                    disabled={right.length === 0}
                    aria-label="move all left"
                  >
                    ≫
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedLeft}
                    disabled={rightChecked.length === 0}
                    aria-label="move selected left"
                  >
                    &gt;
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedRight}
                    disabled={leftChecked.length === 0}
                    aria-label="move selected right"
                  >
                    &lt;
                  </Button>
                  <Button
                    sx={{ my: 0.5 }}
                    variant="outlined"
                    size="small"
                    onClick={handleAllRight}
                    disabled={left.length === 0}
                    aria-label="move all right"
                  >
                    ≪
                  </Button>
                </Grid>
              </Grid>
              <Grid item md={5} className="text-center">
                <div className="transfer-title mb-3">اختصاص‌یافته</div>
                {customList(left)}
              </Grid>

              <Grid item md={12} mt={3} className="d-flex justify-content-center">
                <LoadingButton
                  color="info"
                  loading={loading}
                  variant="outlined"
                  onClick={onEdit}
                >
                  {t("global.register")}
                </LoadingButton>
              </Grid>
            </Grid>
          </Box>
        </CustomModal>
      }
    </>
  );
}